
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDynamicPositioning as ObiDynamicPositioningElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-dynamic-positioning.js';
 
 
 

 
 export const ObiDynamicPositioning = createComponent({
   react: React,
   tagName: 'obi-dynamic-positioning',
   elementClass: ObiDynamicPositioningElement,
   events: {
     
   }
  });
 
 